import { Col, DatePicker, Form, Row } from 'antd';
import '../styles.css'
import dayjs from 'dayjs';
import { SystemConstants } from 'src/common/constants';
import * as Styles from '../styles'
import { useState } from 'react';
import { SystemDescriptions } from 'src/common/descriptions';

const { RangePicker } = DatePicker;

export interface RangePickerDates {
    startDate: dayjs.Dayjs
    endDate: dayjs.Dayjs
}

type Props = {
    rangePickerDefaultValues?: [dayjs.Dayjs, dayjs.Dayjs]
    rangePickerOnChange?: (dateRanges: RangePickerDates) => void
    disabled?: boolean
}

export const RangePickerComponent = (props: Props) => {

    const [rangePickerOpen, setRangePickerOpen] = useState<boolean>(false);
    const [form] = Form.useForm();
    const descriptions = SystemDescriptions.COMPONENTS.SEARCHABLE_TABLE

    const handleRangeChanges = (dateRanges) => {
        if (props.rangePickerOnChange) {
            props.rangePickerOnChange({
                startDate: dateRanges[0],
                endDate: dateRanges[1],
            })
        }
    }

    const renderExtraFooter = () => {

        const triggerDatesChange = (startDate: dayjs.Dayjs, endDate: dayjs.Dayjs) => {
            form.setFieldsValue({
                range_picker: [startDate, endDate],
            })
            setRangePickerOpen(false)
            handleRangeChanges([startDate, endDate])
        }

        const todayClick = () => {
            triggerDatesChange(dayjs(), dayjs())
        }

        const yesterdayClick = () => {
            triggerDatesChange(dayjs().add(-1, 'days'), dayjs().add(-1, 'days'))
        }

        const thisWeekClick = () => {
            triggerDatesChange(dayjs().startOf('week'), dayjs())
        }

        const lastWeekClick = () => {
            triggerDatesChange(
                dayjs().add(-7, 'days').startOf('week'),
                dayjs().add(-7, 'days').endOf('week')
            )
        }

        const thisMonthClick = () => {
            triggerDatesChange(
                dayjs().startOf('month'),
                dayjs()
            )
        }

        const lastMonthClick = () => {
            triggerDatesChange(
                dayjs().add(-1, 'month').startOf('month'),
                dayjs().add(-1, 'month').endOf('month'),
            )
        }

        return <Row>
            <Col md={0} xs={0} sm={0} lg={24}>
                <Styles.RangePickerFooterContainer>
                    <Styles.ShortCutButon
                        size="small"
                        onClick={todayClick}>{descriptions.RANGE_PICKER.SHORTCUTS.TODAY}
                    </Styles.ShortCutButon>
                    <Styles.ShortCutButon
                        size="small"
                        onClick={yesterdayClick}>{descriptions.RANGE_PICKER.SHORTCUTS.YESTERDAY}
                    </Styles.ShortCutButon>
                    <Styles.ShortCutButon
                        size="small"
                        onClick={thisWeekClick}>{descriptions.RANGE_PICKER.SHORTCUTS.THIS_WEEK}
                    </Styles.ShortCutButon>
                    <Styles.ShortCutButon
                        size="small"
                        onClick={lastWeekClick}>{descriptions.RANGE_PICKER.SHORTCUTS.LAST_WEEK}
                    </Styles.ShortCutButon>
                    <Styles.ShortCutButon
                        size="small"
                        onClick={thisMonthClick}>{descriptions.RANGE_PICKER.SHORTCUTS.THIS_MONTH}
                    </Styles.ShortCutButon>
                    <Styles.ShortCutButon
                        size="small"
                        onClick={lastMonthClick}>{descriptions.RANGE_PICKER.SHORTCUTS.LAST_MONTH}
                    </Styles.ShortCutButon>
                </Styles.RangePickerFooterContainer>
            </Col>
        </Row>
    }

    return (
        <Form
            form={form}
            initialValues={{
                range_picker: props.rangePickerDefaultValues,
            }}
            style={{ width: '100%', }}
        >
            <Form.Item
                name="range_picker"
                rules={[{ required: true, message: 'Please select date' }]}
            >
                <RangePicker
                    popupClassName="responsive-calendar"
                    onChange={handleRangeChanges}
                    format={SystemConstants.DATE_FORMAT}
                    // disabledDate={(current) => {
                    //     let customDate = dayjs()
                    //     return current && current > customDate
                    // }}
                    renderExtraFooter={renderExtraFooter}
                    disabled={props.disabled}
                    getPopupContainer={trigger => trigger.parentElement!}
                    style={{ width: '100%' }}
                    open={rangePickerOpen}
                    onOpenChange={(open) => setRangePickerOpen(open)}
                />
            </Form.Item>
        </Form>
    )
}